import { Component } from '@angular/core';
import {ChartParams} from "../../views/chart/chart.component";
import { TranslateService } from '../../translate';
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute} from "@angular/router";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {ModalService} from "../../views/modal/base_modal.component";
import {BaseComponent} from "../../views/base.component";
import * as moment from 'moment-timezone';
import { BillingService2 } from "../billing.service";
import { IStatResult } from "../../models/responce_result.model";

interface IWithdrawalsRecurrentData extends IStatResult {
	dataByGate: {
		headers: object[];
		rows: object[];
	};
	
	dataByTry: {
		headers: object[];
		rows: object[];
	};
}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'withdrawals-recurrent',
	templateUrl: './withdrawals-recurrent.component.html',
	styles: [
		'table.by_gate th:nth-child(n + 2) { text-align: center; }',
		'table.by_gate td { text-align: center; }',
		'table.by_gate th:nth-child(3) { background-color: #fff3cd; }',
		'table.by_gate td:nth-child(3) { background-color: #fff3cd; }',
		'table.by_gate td:nth-child(4) { background-color: #fff3cd; }',
		'table.by_gate th:nth-child(2n + 4) { background-color: #d1ecf1; }',
		'table.by_gate td:nth-child(6n + 5) { background-color: #d1ecf1; }', 
		'table.by_gate td:nth-child(6n + 6) { background-color: #d1ecf1; }',
		'table.by_gate td:nth-child(6n + 7) { background-color: #d1ecf1; }',

		'table.by_try th:nth-child(n + 2) { text-align: center; }',
		'table.by_try td { text-align: center; }',
		'table.by_try th:nth-child(3) { background-color: #fff3cd; }',
		'table.by_try td:nth-child(3) { background-color: #fff3cd; }',
		'table.by_try td:nth-child(4) { background-color: #fff3cd; }',
		'table.by_try th:nth-child(2n + 4) { background-color: #d1ecf1; }',
		'table.by_try td:nth-child(4n + 5) { background-color: #d1ecf1; }',
		'table.by_try td:nth-child(4n + 6) { background-color: #d1ecf1; }',
	]
})
export class WithdrawalsRecurrentComponent extends BaseComponent {
	withdrawalsRecurrentByGateChart = new ChartParams();
	withdrawalsRecurrentByTryChart = new ChartParams();
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateTime', 'dateCreated', 'datePaid', 'dateSiteCreated', 'datePublished'],
		dateType: 'dateTime'
	};
	
	dataByGate = {
		headers: [],
		rows: []
	};

	dataByTry = {
		headers: [],
		rows: []
	};
	
	statsByGateLoader: boolean = false;
	statsByTryLoader: boolean = false;
	withdrawalsRecurrentPercentLoader: number = 100;
	
	i18n = {};
	
	constructor(
		public translate: TranslateService,
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public modalService: ModalService,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);

		const me = this;

		me.i18n['month']  = me.translate.__A('filterForm.tariffVariants.month');
		me.i18n['wait']   = me.translate.__A('billing.expired_paid.expected recurents');
		me.i18n['rebill'] = me.translate.__A('billing.expired_paid.recurents');

		me.withdrawalsRecurrentByGateChart.setOptions({
			title: 'По гейтам',
			axis: {
				y: {
					tick: {
						format: function (d) {
							return d + '%';
						}
					}
				}
			}
		});

		me.withdrawalsRecurrentByTryChart.setOptions({
			title: 'По попыткам',
			axis: {
				y: {
					max: 100,
					tick: {
						format: function (d) {
							return d + '%';
						}
					}
				}
			}
		});
	}
	
	async getData() {
		this.withdrawalsRecurrentPercentLoader = 0;

		const tickM = moment().startOf('month');
		const endM = moment('2018-12-01');

		let i = 0;
		const tick = 100 / tickM.diff(endM, 'months');

		while(tickM.isAfter(endM)) {
			const groupDate = tickM.format('YYYY-MM-DD');
			const { dataByGate, dataByTry } = await this.service2.withdrawalsRecurrent.stats<IWithdrawalsRecurrentData>(
				{ ...this.filter.filterParams, groupDate, }
			).toPromise();

			if(this.dataByGate.headers.length === 0) {
				this.dataByGate.headers = dataByGate.headers;
			}
			if(this.dataByTry.headers.length === 0) {
				this.dataByTry.headers = dataByTry.headers;
			}
			this.dataByGate.rows.push(dataByGate.rows[0]);
			this.dataByTry.rows.push(dataByTry.rows[0]);

			tickM.add(-1, 'month');
			i++;
			this.withdrawalsRecurrentPercentLoader = Math.ceil(i * tick);
		}

		this.withdrawalsRecurrentPercentLoader = 100;

		this.withdrawalsRecurrentByGateChart.data = this.extractChartData(this.dataByGate, 'ByGate');
		this.withdrawalsRecurrentByTryChart.data = this.extractChartData(this.dataByTry, 'ByTry');
	}
	
	
	extractChartData(data, chartId) {
		const chartData = [];
		const x = data.rows.reduce((p, c) => {p.push(c[0]); return p;}, ['x']);
		for (let i = 2; i < data.headers.length; i++) {
			const y = [];
			y.push(data.headers[i].title);

			for(const row of data.rows) {
				x.push(row[0]);
				if(chartId === 'ByTry') {
					if(i === 2) {
						y.push((parseInt(row[3], 10) || 0));
					} else {
						y.push((parseInt(row[(i * 2) - 1], 10) || 0));
					}
				}	else {
					y.push((parseInt(row[(i * 3) - 3], 10) || 0));
				}
			}

			chartData.push(y);
		}
		chartData.unshift(x);

		return chartData;
	}
}
